import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'containers/withRouter';
import RemoteDataProvider from './RemoteDataProvider';

const InboxedBankingDocumentsContext = React.createContext();

function providesInboxedBankingDocuments(Component) {
  class RemoteInboxedBankingDocuments extends React.Component {
    render() {
      const baseURL = `/dossiers/${this.props.match.params.dossierId}/inboxed-banking-documents`;

      return (
        <RemoteDataProvider
          scope="root"
          baseURL={baseURL}
          isCollection
          updateStrategy="fetch"
          render={(remoteData) => {
            return (
              <InboxedBankingDocumentsContext.Provider value={remoteData}>
                <Component {...this.props} />
              </InboxedBankingDocumentsContext.Provider>
            );
          }}
        />
      );
    }
  }

  RemoteInboxedBankingDocuments.propTypes = {
    match: PropTypes.object.isRequired,
  };

  return withRouter(RemoteInboxedBankingDocuments);
}

function consumesInboxedBankingDocuments(Component, provideValueAs = 'inboxedBankingDocuments') {
  return function ComponentThatConsumesInboxedBankingDocuments(props) {
    return (
      <InboxedBankingDocumentsContext.Consumer>
        {(remoteData) => {
          const consumedProps = {
            remoteInboxedBankingDocuments: remoteData,
            [provideValueAs]: remoteData.value,
          };

          return <Component {...props} {...consumedProps} />;
        }}
      </InboxedBankingDocumentsContext.Consumer>
    );
  };
}

export { providesInboxedBankingDocuments, consumesInboxedBankingDocuments };
